import {
    Accordion,
    AccordionContent,
    AccordionHeader,
} from '@eventbrite/eds-accordion';
import { GenericLazyString, gettext } from '@eventbrite/i18n';
import { Divider, Typography } from '@eventbrite/marmalade';
import React, { useState } from 'react';
import { QUESTION_ANSWER } from './constants';
import styles from './FAQSection.module.scss';

export type FAQItemProps = {
    questionText: string | GenericLazyString;
    answer: Array<{
        heading: string | GenericLazyString;
        text?: string | GenericLazyString;
        linkText?: string | GenericLazyString;
        link?: {
            [key: string]: string;
        };
    }>;
};

export const FAQItem: React.FunctionComponent<FAQItemProps> = (props) => {
    const [enterPress, toggle] = useState(false);
    const handleKeyPress = (event: React.KeyboardEvent) => {
        if (event.key == 'Enter') {
            toggle(!enterPress);
        }
    };
    return (
        <div
            itemScope
            itemProp="mainEntity"
            itemType="https://schema.org/Question"
            onKeyDown={handleKeyPress}
            tabIndex={0}
        >
            <Accordion isExpanded={enterPress}>
                <AccordionHeader>
                    <div itemProp="name">
                        <Typography
                            as="h2"
                            variant="body-md-bold"
                            color="ui-800"
                        >
                            {props.questionText}
                        </Typography>
                    </div>
                </AccordionHeader>
                <AccordionContent>
                    <div
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                        tabIndex={0}
                    >
                        <div className={styles.answerSection} itemProp="text">
                            {props.answer.map(
                                ({ heading, text, linkText }, index) => (
                                    <div
                                        className={styles.answerPara}
                                        key={'answer' + index.toString()}
                                    >
                                        {heading && (
                                            <Typography
                                                as="span"
                                                variant="body-md-bold"
                                                color="ui-700"
                                                className={styles.answerHeading}
                                            >
                                                {heading}
                                            </Typography>
                                        )}

                                        {text && (
                                            <Typography
                                                as="h2"
                                                variant="body-md"
                                                color="ui-700"
                                            >
                                                {text}
                                            </Typography>
                                        )}
                                        {linkText && (
                                            <div
                                                color="ui-700"
                                                // eslint-disable-next-line react/no-danger
                                                dangerouslySetInnerHTML={{
                                                    __html: linkText.toString(),
                                                }}
                                            />
                                        )}
                                    </div>
                                ),
                            )}
                        </div>
                    </div>
                </AccordionContent>
            </Accordion>
            <Divider />
        </div>
    );
};

export const FAQSection: React.FunctionComponent = () => {
    return (
        <>
            <div className={styles.sectionContainer}>
                <div className={styles.headerContainer}>
                    <Typography
                        color="neutral-1000"
                        variant="heading-lg"
                        className={styles.headingTitle}
                    >
                        {gettext('FAQs')}
                    </Typography>
                </div>
                <>
                    <section itemScope itemType="https://schema.org/FAQPage">
                        <div className={styles.sectionContent}>
                            {QUESTION_ANSWER.map(
                                ({ question, answer }, index) => (
                                    <FAQItem
                                        questionText={question}
                                        answer={answer}
                                        key={index.toString()}
                                    />
                                ),
                            )}
                        </div>
                    </section>
                </>
            </div>
        </>
    );
};
